import AgencyNav from './AgencyNav';
import AgencyFooter from './AgencyFooter';
import Hero from './sections/Hero';
import ProofStrip from './sections/ProofStrip';
import Services from './sections/Services';
import Start from './sections/Start';
import ProblemRescue from './sections/ProblemRescue';
import Process from './sections/Process';
import StatusBoard from './sections/StatusBoard';
import ClosingCTA from './sections/ClosingCTA';
import Seo from './Seo';

export default function AgencyHome() {
  return (
    <div className="fa-scope min-h-screen">
      <Seo
        title="FRONTECH — AI systems that make it into production"
        description="AI engineering firm that builds, deploys, and runs production-grade AI systems for mid-market businesses — support agents, ops workflows, and sales pipelines that actually ship."
        path="/"
      />
      <AgencyNav />
      <main>
        <Hero />
        <Services />
        <Start />
        <Process />
        <ProblemRescue />
        <StatusBoard />
        <ProofStrip />
        <ClosingCTA />
      </main>
      <AgencyFooter />
    </div>
  );
}
